import React from 'react';
import { Button, ButtonGroup } from "react-bootstrap";

const Row = ({ country, cpc, onRemove }) => {
    return (<tr>
        <td style={{ textAlign: 'left' }}>{country}</td>
        <td>{cpc}</td>
        <td>
            <ButtonGroup>
                <Button bsStyle="danger" onClick={() => onRemove(country)}>Remove</Button>
            </ButtonGroup>
        </td>
    </tr>);
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkBannerDefaultOffersCpc/components/Table/components/Row/index.js